module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/msysov9-6587171885d0095978d98ccd17de8408.jpg";